import { AppLoadedState } from './../app.loaded.state';
import { ToastType } from './../toast/toast.enum';
import { Gift } from './../gift/gift';
import { Subject } from 'rxjs/Subject';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore } from 'angularfire2/firestore';
import { AuthService, User } from './../user/auth.service';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Registry } from '../registry/registry';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit, OnDestroy {
  isVerified = true;
  isPublished = false;
  trailDaysRemaining: number;
  isOnRegistryPage = false;
  gifts: Gift[];
  showPublishBanner = false;
  emailSent = false;
  shareDimissed = localStorage.getItem('toast_' + ToastType.share) === 'true';
  appLoaded = true;
  registry: Registry;
  user: User;
  email: string;
  private ngUnsubscribe: Subject<void> = new Subject();

  constructor(private _activeRoute: ActivatedRoute,
    private _router: Router,
    private _registryFirebaseService: RegistryFirebaseService,
    private _authService: AuthService,
  ) {
    const mainComponent: any = this._activeRoute.component;
    this.isOnRegistryPage = mainComponent.name === 'RegistryComponent';
    _router.events.takeUntil(this.ngUnsubscribe).subscribe((event) => {

      if (event instanceof NavigationEnd) {
        this.isOnRegistryPage = (event.url.toLowerCase() === '/registry'
          || event.url.toLowerCase() === '/registry/welcome'
          || event.url.toLowerCase() === '/registry/publish'
          || event.url.toLowerCase() === '/registry/share');

          this.showPublishBanner = (event.url.toLowerCase() === '/registry'
          || event.url.toLowerCase() === '/registry/welcome'
          || event.url.toLowerCase() === '/overview'
          || event.url.toLowerCase().includes('/registry/settings')
          || event.url.toLowerCase().includes('/registry/settings/notifications')
          || event.url.toLowerCase() === '/registry/contributions'
          || event.url.toLowerCase() === '/registry/publish'
          || event.url.toLowerCase() === '/registry/share');

        if (this.isOnRegistryPage || this.showPublishBanner) {
          this._authService.user.takeUntil(this.ngUnsubscribe).subscribe(user => {

            if (user) {
              this.user = user;
              this.email = user.email;
              this.isVerified = user.emailVerified;
              this._registryFirebaseService.registryForUser(user).subscribe(reg => {
                this.registry = reg;
                if (reg) {
                  this.isPublished = reg.isLive;
                  this.checkTrailDays();
                }
              });


            }
          });

        }
      }
    });
  }

  shareBannerNotDismissed() {
    return this.appLoaded && this.isOnRegistryPage && this.isVerified
      && this.isPublished && !this.shareDimissed;
  }

  emailNotVerified(): boolean {
    return this.appLoaded && this.isOnRegistryPage && !this.isVerified;
  }

  regNotPublished(): boolean {

    return this.appLoaded && this.isOnRegistryPage && this.isVerified && !this.isPublished
      && (this.gifts && this.gifts.length >= 1);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  dismissShareToast() {
    this.shareDimissed = true;
    localStorage.setItem('toast_' + ToastType.share, 'true');
  }

  dismissGuestToast() {
    this.shareDimissed = true;
    localStorage.setItem('toast_' + ToastType.guest, 'true');
  }

  ngOnInit() {


    this.registry = this._activeRoute.snapshot.data.registry;
    this.gifts = this._activeRoute.snapshot.data.gifts;
    if (this.registry) {
      this.isPublished = this.registry.isLive === true;

    }

 this.checkTrailDays();
  }

  checkTrailDays() {
    if (this.registry && this.registry.paid !== undefined && this.registry.paid === false) {


      const Difference_In_Time: number = new Date(this.registry.created).setHours(24 * 7 * 1 + 24) - new Date().getTime();
      const daysLeft = Difference_In_Time / (1000 * 3600 * 24);
      this.trailDaysRemaining = Math.floor(daysLeft);
      if (this.trailDaysRemaining <= 0) {
       // this._router.navigateByUrl('/visibility?expired=true');  //remove redirect for trial
      }

    }
   }
  reSendEmail() {
    this._authService.sendEmailVerification(this.user.email, this.user.uid);
    this.emailSent = true;
  }

  showBanner() {
  }

}



// WEBPACK FOOTER //
// ./src/app/banner/banner.component.ts